<template>
    <div class="" id="bookingDetailPage" v-show="!isHidePage">
      <!--抖音核销-->
      <template v-if="getTikTokCouponStatus(booking.tikTokCouponStatus) && booking.status != 'CANCELLED'">
        <div v-if="booking.tikTokCouponStatus === 1" class="tik-tok-header">您的申请已收到，会为您尽快完成审核。<br/>（预计48小时内完成审核）<br/>请您尽快在抖音完成预约以便客服专员完成审核，谢谢。</div>
        <div v-else-if="booking.tikTokCouponStatus === 3" class="tik-tok-header">抱歉，您未在规定时间内提交审核，请重新发起申请。</div>
      </template>
      <template v-else>
        <template v-if="booking.localStatus==15 || booking.status == 'CANCELLED'">
          <div class="count-down">
            很遗憾，您未在规定时间内完成支付，订单已取消！<br>
            请重新下单
          </div>
        </template>
        <template v-else-if="booking.localStatus != 15 && booking.localStatus != 10 && booking.status != 'CANCELLED'">
          <div class="count-down">
            您已下单成功，该订单将保留到 <span>{{retainTime}}</span>，<br>
            请尽快完成支付！
          </div>
        </template>
        <template v-else-if="booking.localStatus == 10 || booking.status == 'BOOKED'">
          <div class="count-down" style="display: none"></div>
        </template>
        <template v-else>
          <div class="count-down">
            您的订单暂时不能付款，请联系客服400-820-7786
          </div>
        </template>
      </template>
        <div class="route-info scroll-container">
            <div class="privacy-layout">
              <privacy-button @privacy-switch="reload" type="btn-mini" :refresh="refresh"></privacy-button>
            </div>
            <div class="route-name-box">
              <div class="route-name-box__left">{{cruise.cruiseRoute}}</div>
              <CruisePortsPopup class="route-name-box__right"
                                :is-sale="bookingDetail.isSale"
                                :ship-code="cruise.shipCode"
                                :sail-date="cruise.sailDate"></CruisePortsPopup>
            </div>
            <div class="route-ship">{{cruise.sailDays}}天{{cruise.sailDays - 1}}晚 {{cruise.shipName}}</div>
            <div class="route-row">
                <div class="route-row-txt">{{bookingDetail.sailDateBegin}} - {{bookingDetail.sailDateEnd}}</div>
                <div @click="goToWxLink" class="stateRoomBidding"
                     :style="{ background:upgradeCabinItem.biddingStatus===10||
                     upgradeCabinItem.biddingStatus===40||
                     upgradeCabinItem.biddingStatus===50?'#5cb139':'' }"
                     v-if="upgradeCabinItem.displayBiddingEntrance">
                  <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/bidding/bidding-icon-white3.svg" alt="">
                  <div v-if="upgradeCabinItem.canBidding">
                    <span v-if="upgradeCabinItem.biddingStatus==20">未竞价成功</span>
                    <span v-else>竞价升房</span>
                  </div>
                  <div v-if="!upgradeCabinItem.canBidding">
                    <span>{{getBiddingStatusText(upgradeCabinItem.biddingStatus)}}</span>
                  </div>
                </div>
            </div>
            <div class="route-row">
                <div class="route-row-title">联 系 人</div>
                <div class="route-row-txt route-row-txt3">
                    ：{{contactName}}
                    <router-link :to="changeBookingContactLink"
                        class="modify-box external">
                        <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon09.png">
                        修改联系人信息
                    </router-link>
                </div>
            </div>
            <div class="route-row2">
                <div class="route-row2-txt">{{contact.telephone}}</div>
                <div class="route-row2-txt">{{contact.email}}</div>
            </div>
        </div>
        <div class="order scroll-container">
            <div class="order-info">
                <div class="order-row1">
                    <div class="order-row1-l">
                        <div class="order-txt1">船票预订号：</div>
                        <div class="order-txt2">{{booking.bookingId}}</div>
                    </div>
                    <div class="order-row1-r">
                        <template v-if="getTikTokCouponStatus(booking.tikTokCouponStatus) && booking.status != 'CANCELLED'">
                          <div class="tik-tok-coupon-status common-ellipsis">
                            {{getTikTokCouponStatus(booking.tikTokCouponStatus)}}<span v-if="booking.tikTokRejectReason">({{booking.tikTokRejectReason}})</span>
                          </div>
                        </template>
                        <template v-else>
                          <span v-if="booking.localStatus == 15 || booking.status == 'CANCELLED'">已取消</span>
                          <span v-else-if="booking.localStatus == 10 || booking.status == 'BOOKED'">
                            <span v-if="canPay || isNotPayInFull">
                                <span v-if="payAmount > 0">未付全款</span>
                                <span v-else>未付款</span>
                            </span>
                            <span v-else>已付款</span>
                          </span>
                          <span v-else-if="booking.localStatus != 15 && booking.localStatus != 10 && booking.status != 'CANCELLED'">未付款</span>
                        </template>
                    </div>
                </div>


                <div class="order-row2">
                    <div class="order-row2-l order-txt3">
                        <div>游轮客房：{{stateroomName + '_' + stateroomCategoryCode}}</div>
                        <img v-if="bookingDetail.groupType == 'QIAOHU' || bookingDetail.groupType=='QIAOHU_AL'" @click="showQiaohuPopup"
                            class="QIAOHU_CSS qiaohu_tag" src="https://resource.rcclchina.com.cn/QIAOHU/Mobile_QIAOHU.jpg">
                        <img v-else-if="bookingDetail.groupType == 'STARRYSKY'" @click="showStarrySkyPopup"
                             class="STARRYSKY_CSS starry_sky_tag" src="https://resource.rcclchina.com.cn/STARRYSKY/MB_icon.png">
                        <img v-else-if="bookingDetail.groupType === 'PCPGIFT'"
                           @click.stop.prevent="showCustomThemePopup(bookingDetail.stateroomCategory.personalizedStateroomInfo)"
                           class="PCP_GIFT_THEME_CSS custom_sky_tag"
                           :src="bookingDetail.stateroomCategory.personalizedStateroomInfo?.roomIconImage">
                        <img v-else-if="bookingDetail.groupType == 'CUSTOM'"
                           @click.stop.prevent="showCustomThemePopup(bookingDetail.stateroomCategory.personalizedStateroomInfo)"
                             class="CUSTOM_THEME_CSS custom_sky_tag"
                           :src="bookingDetail.stateroomCategory.personalizedStateroomInfo?.roomIconImage">
                    </div>
                </div>
                <div class="order-row2">

                    <div class="order-row2-l order-txt5">
                        <span>房间号：{{booking.stateroomNumber == 'GTY'? '随机': booking.stateroomNumber}}</span>
                        <img v-if="booking.connectId && booking.connectId.length > 0" @click="showConnectRoomPopup"
                            class="c_con_BD" src="https://resource.rcclchina.com.cn/ConnectStateroom/Mobile_ConnectIcon.png">
                        <router-link v-if="booking.encConnectBookingId && booking.encConnectBookingId.length > 0"
                            :to="{ name: 'BookingDetail', query: { bookingId: booking.encConnectBookingId}}"
                            class="external">
                            <img class="c_con_BDLook" src="https://resource.rcclchina.com.cn/ConnectStateroom/connectBookingId.png">
                        </router-link>

                    </div>
                </div>
                <div class="order-row2-r c_order-row2-r">
                    <p class="order-badge2 js-popupBtn2" data-popupname="gtyTip" @click="showGtyTips()" v-if="booking.stateroomNumber == 'GTY'">
                        随机房须知
                        <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon08.png" />
                    </p>
                    <p class="order-badge js-popupBtn" data-popupname="cabinDetail" @click="showStateroomDetailPopup()">舱房详情</p>
                    <p class="order-badge js-cancelRule" @click="showNrpPopup()">{{nrpText}}</p>
                    <div @click="goToWxLink" class="stateRoomWxLink" v-if="upgradeCabinItem && upgradeCabinItem.displayBiddingEntrance">
                      <div v-if="upgradeCabinItem.canBidding">
                        <span v-if="upgradeCabinItem.biddingStatus==20">未竞价成功</span>
                        <span v-else>竞价升房</span>
                      </div>
                      <div v-if="!upgradeCabinItem.canBidding">
                         <span :style="upgradeCabinItem.biddingStatus===10||upgradeCabinItem.biddingStatus===40||upgradeCabinItem.biddingStatus===50?'color: #5cb139':''" >
                           {{getBiddingStatusText(upgradeCabinItem.biddingStatus)}}</span>
                      </div>
                      <img
                          v-if="upgradeCabinItem.biddingStatus!==10||upgradeCabinItem.biddingStatus!==40||upgradeCabinItem.biddingStatus!==50"
                          src="https://resource.rcclchina.com.cn/wechatMiniProgram/bidding/right-arrow.png" alt="">
                      <img v-else src="https://resource.rcclchina.com.cn/wechatMiniProgram/bidding/right-arrow-success.png" alt="">
                    </div>
                </div>
                <div class="order-line"></div>
                <template v-if="bookingDetail.canEditGratuities">
                  <div class="cabinItem-checkbox">
                    <div class="cabinItem-checkbox-l">
                      预付服务费<img @click="gratuitiesPopupOpen" src="https://resource.rcclchina.com.cn/RcclHP/icon08.png" />
                    </div>
                    <div class="cabinItem-checkbox-r">
                      <div @click="switchGratuities" class="switchBar" :class="{'active': gratuitiesSwitch}">
                        <div class="switchBarSlider"></div>
                      </div>
                    </div>
                  </div>
                  <div class="order-line"></div>
                </template>
            </div>

            <template v-if="booking.allowFillGuest">
              <div class="booking-fill-guests">
                <GuestSelectView v-for="(guest, j) in guestsShow"
                                 :guest="guest"
                                 :idx="j"
                                 contactMode="guest"
                                 :sessionToken="booking.sessionToken"
                                 :key="'booking_guest_' + j"
                                 @selectClick="showContactList"></GuestSelectView>
                <div class="common-clr"></div>
                <div v-if="booking.allowFillGuest" class="cabinItem-un-filled">
                  <img class="icon" :src="`${imgUrl}/icons/icon-warning-triangle.png`"/>
                  <div class="text">建议开航<span class="fc-red">45</span>天前补全全部乘客信息，开航前<span class="fc-red">7</span>天及以内不可再进行修改</div>
                </div>
                <button class="booking-fill-guests-btn" @click="submitFillGuests">提交信息</button>
<!--                <div-->
<!--                    class="roomDetail-guestsInfoDetail"-->
<!--                    v-for="(guest, j) in guestsShow"-->
<!--                    :key="'booking_guest_' + j">-->
<!--                  -->
<!--                </div>-->
              </div>
              <div class="order-line"></div>
            </template>
            <div class="order-passenger" v-for="(guest, i) in bookingGuests" :key="('guest_' + i)">
                <div class="passenger-name">
                    <span class="cn" v-if="guest.passengerName">{{guest.passengerName}}</span>
                    <span class="en">{{guest.enPassengerName}}</span>
                </div>
                <div v-if="!guest.unFilledGuest" class="passenger-info">
                    <div class="passenger-info-row order-txt4">
                        <p v-if="guest.gender == 'M'">男</p>
                        <p v-else-if="guest.gender == 'F'">女</p>
                        <p v-if="guest.dateOfBirthStr&&guest.dateOfBirthStr.length >= 10">{{guest.dateOfBirthStr.substring(0, 10)}}</p>
                    </div>
                    <div class="passenger-info-row order-txt4">
                        <p v-if="guest.telephone">{{guest.telephone}}</p>
                        <p v-if="guest.email">{{guest.email}}</p>
                    </div>
                    <template v-if="!guest.passPortNum||guest.passPortNum.length==0||!guest.passPortExpirationDate||guest.passPortExpirationDate.length==0">
                      <!-- <div class="passenger-info-row">
                          <a class="modify-box external" @click="onChangeGuestPassport(guest)">
                              <img src="https://resource.rcclchina.com.cn/bookingPay/icon09.png">
                              补全护照信息
                          </a>
                      </div> -->
                    </template>
                    <template v-else>
                      <div class="passenger-info-row order-txt4">
                          <p>{{getGuestPassport(guest)}}</p>
                          <p>有效期至 {{getPassPortExpirationDate(guest)}}</p>
                      </div>
                    </template>
                </div>

                <div v-if="guestsPrice && guestsPrice.length > i && isShowPrice">
                    <div class="passenger-service">
                        <div class="passenger-service-l">零售指导价</div>
                        <div class="passenger-service-r"><span>{{currency}}</span>
                            {{guestsPrice[i].originalPrice}}
                        </div>
                    </div>
                    <div class="passenger-service">
                        <div class="passenger-service-l">港务税费</div>
                        <div class="passenger-service-r"><span>{{currency}}</span>{{guestsPrice[i].taxPrice}}</div>
                    </div>
                    <div v-if="showGratuities" class="passenger-service">
                      <div class="passenger-service-l">服务费</div>
                      <div class="passenger-service-r"><span>{{currency}}</span>{{guestsPrice[i].gratuities}}</div>
                    </div>
                </div>

                <div class="order-line"></div>
            </div>

            <div class="specialBookingArea" v-if="bookingPrice && bookingGuestSpecials && bookingGuestSpecials.length > 0" @click="showSpecialBookingPopup">
                <div class="item-inner item-sp">
                    <div class="item-title-row">
                        <div class="item-title">
                            <img class="special-icon" src="https://resource.rcclchina.com.cn/wechatMiniProgram/WechatMiniProgramImage/birthdayRoom/birthday_icon.png" />
                            <span class="specialBookingName">{{specialBookingName}}</span>
                            <img class="question-icon item-click" src="https://resource.rcclchina.com.cn/RcclHP/icon08.png">
                        </div>
                        <div class="item-price">{{currency}}{{bookingPrice.priceInfo.specialBirthdayPrice}}</div>
                    </div>
                    <div class="item-content">
                        <div class="item-selected-content">
                            <div class="itemContent">已选择 <span class="selectedUnderline">{{selectedGuestName}}</span> 享受生日礼遇</div>
                            <div class="itemContent">
                                将于 <span class="selectedUnderline">{{selectedDate}} {{selectedTimeslot}} {{selectedPlace}}</span> 享用生日蛋糕
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-line"></div>
            </div>
            <template v-if="bookingDetail.groupType==='PCPGIFT'">
              <PcpGiftView :giftInfo="bookingDetail.stateroomCategory?.personalizedStateroomInfo"
                         :shipCode="booking.shipCode"
                         :sailDate="booking.sailDate"
                         :guestNumber="booking.bookingGuests.length"
                         @open="showCustomThemePopup"
                         is-on-page-popup
                         pageName="BookingDetail"
                         @getPcpGift="getPcpGift"></PcpGiftView>
              <div class="order-line"></div>
            </template>
            <div class="order-price" v-if="bookingPrice && bookingPrice.priceInfo && isShowPrice">
                <div class="order-price-title">
                    <div class="order-price-title-l">零售指导价合计</div>
                    <div class="order-price-title-r"><span>{{currency}}</span>
                        {{bookingPrice.priceInfo.originalPrice}}
                    </div>
                </div>
                <div v-if="bookingPrice && bookingPrice.prices && bookingPrice.prices.priceInfo">
                    <div class="order-price-title">
                        <div class="order-price-row2-l">船票优惠详情</div>
                    </div>
                    <div class="order-price-row" v-for="(priceItem, i) in discountPriceItems" :key="('discount_' + i)">
                        <div class="order-price-row-l">{{priceItem.description}}</div>
                        <div class="order-price-row-r"><span>-{{currency}}</span>{{priceItem.amount.replace('-', '')}}</div>
                    </div>

                    <div class="order-price-row" v-if="bookingDetail.obcAmount > 0">
                        <div class="order-price-row-l">船上消费抵用金</div>
                        <div class="order-price-row-r">$ {{bookingDetail.obcAmount}}</div>
                    </div>

                    <div class="order-price-row2" v-if="bookingDetail.groupType != 'QIAOHU'">
                        <div class="order-price-title-l">优惠后船票合计</div>
                        <div class="order-price-title-r"><span>{{currency}}</span>
                            {{discountedPrice}}
                        </div>
                    </div>
                    <div class="order-price-title" v-if="bookingPrice && bookingPrice.priceInfo && bookingPrice.priceInfo.biddingPrice">
                      <div class="order-price-title-l">升房费</div>
                      <div class="order-price-title-r"><span>{{currency}}</span>
                        {{bookingPrice.priceInfo.biddingPrice}}
                      </div>
                    </div>
                </div>

                <div class="order-price-row2" >
                    <div class="order-price-title-l">港务税务合计</div>
                    <div class="order-price-title-r"><span>{{currency}}</span>{{bookingPrice.priceInfo.taxPrice}}</div>
                </div>
                <div v-if="showGratuities" class="order-price-row2">
                  <div class="order-price-title-l">服务费合计</div>
                  <div class="order-price-title-r"><span>{{currency}}</span>{{bookingDetail.gratuities}}</div>
                </div>
                <div v-if="bookingGuestSpecials && bookingGuestSpecials.length > 0" class="order-price-row2">
                  <div class="order-price-title-l">生日礼遇</div>
                  <div class="order-price-title-r"><span>{{currency}}</span>{{bookingPrice.priceInfo.specialBirthdayPrice}}</div>
                </div>
                <div v-if="bookingDetail.groupType === 'PCPGIFT' && pcpGiftInfo" class="order-price-row2">
                  <div class="order-price-title-l">{{pcpGiftInfo.name}} x{{booking.bookingGuests.length}}</div>
                  <div class="order-price-title-r"><span>{{currency}}</span>{{pcpGiftInfo.price}}</div>
                </div>
              <div class="order-line"></div>
            </div>

            <div class="order-summary" v-if="booking.status != 'CANCELLED'">
                <div v-if="payAmount > 0 && payAmount < booking.amount">
                    <div class="order-summary-row">
                        <div class="order-summary-row-l">已支付订金</div>
                        <div class="order-summary-row-r"><span>{{currency}}</span>{{payAmount}}</div>
                    </div>
                    <div class="order-summary-row">
                        <div class="order-summary-row-l">待支付尾款</div>
                        <div class="order-summary-row-r"><span>{{currency}}</span>{{calculateDecimal(booking.amount - payAmount)}}</div>
                    </div>
                </div>
                <div class="order-summary-row">
                    <div class="order-summary-row-l">合计</div>
                    <div class="order-summary-row-r"><span>{{currency}}</span>{{showGratuities ? booking.includeGratuities : booking.amount}}</div>
                </div>
                <div class="order-summary-jifen" v-if="payAmount > 0 && payAmount < booking.amount && !bookingDetail.canPay">
                    需等待约10个工作日后可支付尾款
                </div>
                <div class="order-summary-jifen" v-if="payAmount == 0 && bookingDetail.canPay && bookingDetail.isDownPayCruise" style="margin-bottom: 5px;">
                    支持订金￥1000/人
                </div>
                <div class="order-summary-jifen" v-if="bookingDetail.bookingIntegral && bookingDetail.bookingIntegral.integral > 0">
                    预计获得<span>{{integral}}</span> 积分
                    <img src="https://resource.rcclchina.com.cn/RcclHP/icon08.png" alt="" @click="showBookingIntegralTips()">
                    <div v-if="isFinishSelfInfo">（需会员本人预订且出行）</div>
                    <div v-else @click="editInfo">（请最晚于<span class="highlight-color">下船日前</span>至<span class="highlight-color">会员中心-完善信息</span>，需会员本人预订且出行可获得积分）</div>
                    <!-- <br/>
                    可至积分商城兑换价值约<span>{{bookingDetail.bookingIntegral.valuation}}</span>元电话卡 -->
                </div>
            </div>
        </div>
        <div class="hsbcBanner" v-if="false">
          <Swiper
              ref="bannerSwiper"
              :options="swiperOptions"
              class="swiper-container swiper-topics topics"
              @click-slide="onShowPopupsImg"
          >
            <SwiperSlide
                v-for="(item, i) in hsbcBanners"
                :key="i"
                class="swiper-slide promoBannerLink external"
            >
              <div>
                <img :src="item.image" alt=""/>
              </div>
            </SwiperSlide>
            <div
                ref="swiper-pagination"
                class="swiper-pagination"
                v-if="hsbcBanners.length > 1"
                slot="pagination"
            ></div>
          </Swiper>
        </div>
        <div class="booking-service" v-if="canShorex && ((payAmount > 0 && booking.status != 'CANCELLED')|| booking.status == 'BOOKED')">
            <!-------------岸上观光---------------->
            <div class="shorex-service" v-if="booking.isRow == false">
                <div class="pay-rule-item">
                    <div class="pay-rule-item-line"></div>
                    <p>岸上观光服务</p>
                </div>
                <div v-if="!selectedShorex && shorexes.length == 0">
                    <div class="shorex-ly">
                        <div class="f-left"></div>
                        <div class="f-right"></div>
                    </div>
                    <div class="shorex-intro">
                        <div class="per-title"></div>
                        <div class="sub-title"></div>
                        <div class="sh">
                            <div></div>
                            <div class="desc">
                              您可以在支付完成后界面选择岸上观光服务，或在船票预订完成后前往皇家行前订网站小程序选订。<br/>
                              您也可以不选订任何行程则视为自助游，您需自行安排目的地游览行程。
                            </div>
<!--                            <div class="desc" @click="goToPcp">-->
<!--                              该航次岸上观光服务尚未开放选订，选订开放后，我们会在第一时间通知您。您也可以密切关注皇家加勒比官方网站，后续可至<span style="color: #408eca" @click="showShorexPopup()">>>皇家行前订</span>进行预订。-->
<!--                            </div>-->
                        </div>
                    </div>
                </div>

                <div v-else-if="!selectedShorex && shorexes.length > 0">
                   <div class="selectShorex-css" @click="goToPcp">
                     <p>尊敬的客人，您尚未预订任何岸上观光行程。皇家官方为您提供多种岸上观光行程，您可至>><span class="up-shorex">皇家行前订</span>自主进行选订。</p>
                     <p>如不进行任何行程选订则视为自助游，您需自行安排目的地游览行程。</p>
                    </div>
                </div>

                <div v-else-if="selectedShorex && selectedShorex.shorexType == 1">
                    <div class="shorex-ly">
                        <div class="f-left">皇家常规游套餐(免费赠送)</div>
                        <div class="imaginary"></div>
                        <div class="f-right up-shorex" @click="showShorexPopup()">升级精品游</div>
                    </div>
                    <div class="shorex-intro" v-for="(tour, j) in selectedShorex.shorexTrips" :key="('tour_'+j)">
                        <div class="per-title">{{tour.tripName}} - {{tour.tripTime}}</div>
                        <div class="sub-title" v-html="tour.description"></div>
                    </div>
                    <div class="shorex-tips">
                        <p>注：</p>
                        <p style="">
                            <span class="parah-num">1)</span>目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。<br/>
                            <span class="parah-num">2)</span>目的地产品及行程可能受天气、航次情况、交通、政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。<br/>
                            <span class="parah-num">3)</span>皇家行前订目前只提供全程观光套餐，您可于登船后购买单一港口观光产品，全程套餐与单一港口观光产品均数量有限，先到先得。
<!--                            <span class="parah-num">3)</span>关于岸上观光产品的咨询、预订和修改，您可以拨打400-820-3187和皇家加勒比游轮度假专家联系。-->
                        </p>
                    </div>
                </div>

                <div v-else-if="selectedShorex && selectedShorex.shorexType == 2">
                    <div class="shorex-ly">
                        <div class="f-left">{{selectedShorex.shorexName}}</div>
                        <div class="imaginary"></div>
                        <div class="f-right up-shorex" @click="showShorexPopup()">修改精品游</div>
                    </div>
                    <div class="shorexTour-intro" v-for="(tour, i) in selectedShorex.shorexTours" :key="('shorexTour_' + i)">
                        <img :src="tour.image" />
                        <div class="shorexTour-Info">
                            <div class="shorexTour-per-title">{{tour.shorexName}}</div>
                            <div class="shorexTour-sub-title">{{tour.shorexBrief}}</div>
                            <div class="shorexTour-sub-title">时长：<span>{{tour.duration}}</span></div>
                            <div class="shorexTour-sub-title">数量：<span>{{bookingGuests.length}}</span></div>
                        </div>
                    </div>
                    <div class="all-imaginary"></div>
                    <div style="margin-bottom: 6px;">
                        <div class="shorexTour-price" v-if="bookingGuests.length > 0 && selectedShorex.price > 0">
                            总计：<span>{{bookingGuests.length * selectedShorex.price}}</span> 美元
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                    <div class="shorex-tips">
                        <p>注：</p>
                        <p style="">
                            <span class="parah-num">1)</span>目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。<br/>
                            <span class="parah-num">2)</span>目的地产品及行程可能因相关政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。<br/>
                            <span class="parah-num">3)</span>皇家行前订目前只提供全程观光优惠套餐。您可于登船后购买单一港口观光产品。优惠套餐与单一港口观光产品均数量有限，先到先得。
<!--                            <span class="parah-num">3)</span>关于岸上观光产品的咨询、预订和修改，您可以拨打400-820-3187和皇家加勒比游轮度假专家联系。-->
                        </p>
                    </div>
                </div>

            </div>
            <div class="shorex-service" v-else>
                <div class="pay-rule-item">
                    <div class="pay-rule-item-line"></div>
                    <p>关于海外航线“预付费类”船上产品或服务的重要说明：</p>
                </div>
                <div >
                    <div class="shorex-intro">
                        <div class="sh">
                            <div></div>
                            <div class="desc">
                              由于技术限制，皇家加勒比国际游轮旗下海外出发航线的船上付费项目暂时无法在皇家行前订官网以及国际官网提前预订和支付（船上付费类项目通常包括：海外目的地的岸上观光，船上各类付费餐饮、娱乐等），请您于登船后进行预订。
                            </div>
<!--                            <div class="desc" @click="goToPcp">-->
<!--                              该航次岸上观光服务尚未开放选订，选订开放后，我们会在第一时间通知您。您也可以密切关注皇家加勒比官方网站，后续可至<span style="color: #408eca" @click="showShorexPopup()">>>皇家行前订</span>进行预订。-->
<!--                            </div>-->
                        </div>
                    </div>
                </div>


            </div>

            <!---皇家行前订-->
            <div class="margin-bottom-10">
                <BookingDetailPcp
                v-if="booking.status != 'CANCELLED' && booking.isRow == false"
                :pcpOrder="bookingDetail.pcpOrderViewModel"
                :booking="booking"
                />
            </div>

            <div class="orderNotesCon">
                <div class="itemPackage">

                    <div class="package-orderNotes-category" v-if="bookingDetail.cruiseVisa && bookingDetail.cruiseVisa.insuranceContent">

                        <div class="package-orderNotes-headline js-openNotesBtn" @click="showVisaPopup()">
                            <div class="package-orderNotes-headline-l">游轮保险</div>
                            <div class="package-orderNotes-headline-r">
                                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightB.png">
                            </div>
                        </div>
                        <div class="package-orderNotes-headlineCon js-categoryDetail">
                            <div class="reservation_desc">
                            </div>
                        </div>
                    </div>

                    <div class="package-orderNotes-category" v-if="isShowSpecialBooking">

                        <div class="package-orderNotes-headline js-openNotesBtn" @click="showVisaPopup()">
                            <div class="package-orderNotes-headline-l">生日礼遇退改规则</div>
                            <div class="package-orderNotes-headline-r">
                                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightB.png">
                            </div>
                        </div>
                        <div class="package-orderNotes-headlineCon js-categoryDetail">
                            <div class="reservation_desc">
                            </div>
                        </div>
                    </div>

                    <div class="package-orderNotes-category">

                        <div class="package-orderNotes-headline js-openNotesBtn" @click="showVisaPopup()">
                            <div class="package-orderNotes-headline-l">办理登船注意事项</div>
                            <div class="package-orderNotes-headline-r">
                                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightB.png">
                            </div>
                        </div>
                        <div class="package-orderNotes-headlineCon js-categoryDetail">
                            <div class="reservation_desc">
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- 底部 -->
        <template v-if="getTikTokCouponStatus(booking.tikTokCouponStatus)===''">
          <div class="toolbar" v-if="!isExpired && (bookingDetail.canPay || booking.localStatus != 10)">
               <div class="toolbar-inner" v-if="booking.localStatus == 15 || booking.status == 'CANCELLED'">
                  <div class="toPay-m">
                      <div class="toPay-m-l">
                          <div class="toPay-m-txt">应付总计<span class="unit">{{currency}}</span></div>
                          <div class="toPay-m-price">
                              {{booking.amount}}
                          </div>
                      </div>
                      <router-link :to="{ name: 'CruiseDetail', query: { shipCode: this.cruise.shipCode, sailDate: this.cruise.sailDate}}"
                      class="toPay-m-r external">重新下单</router-link>
                  </div>
              </div>

              <div class="toolbar-inner" v-else-if="bookingDetail.canPay && payAmount == 0">
                  <div class="toPay-m">
                      <div class="toPay-m-l">
                          <div class="toPay-m-txt">应付总计<span class="unit">{{currency}}</span></div>
                          <div class="toPay-m-price">
                            {{showGratuities ? booking.includeGratuities : booking.amount}}
                          </div>
                      </div>
                      <router-link :to="{ name: 'Pay', query: { bookingId: booking.encBookingId }}" class="toPay-m-r external">立即支付</router-link>
                  </div>
              </div>

              <div class="toolbar-inner" v-else-if="bookingDetail.canPay && payAmount > 0">
                  <div class="toPay-m">
                      <div class="toPay-m-l">
                          <div class="toPay-m-txt">还需支付<span class="unit">{{currency}}</span></div>
                          <div class="toPay-m-price">
                              {{bookingDetail.balanceDue}}
                          </div>
                      </div>
                      <router-link :to="{ name: 'Pay', query: { bookingId: booking.encBookingId }}" class="toPay-m-r external">立即支付</router-link>
                  </div>
              </div>
          </div>
        </template>

        <!-- 联系人列表 -->
        <GuestInfoContactList
            :onGoBack="closeContactList"
            :isShow="isShowContactList"
            :desc-text="guestInfoDesc"
            :maxCount="maxGuestCount"
            :contactMode="contactMode"
            :selectContactIds="selectContactIds"
            :onGuestContactConfirm="onGuestContactConfirm"
            :closeContactEdit="closeContactEdit"
            :showContactEdit="showContactEdit"
            :isShowContactEditPopup="isShowContactEdit"
        />

        <BookingDetailShorex
            :isShow="isShowShorexPopup"
            :shorexes="shorexes"
            :onGoBack="closeShorexPopup"
            :booking="booking"
            :onSelectShorex="onSelectShorex"
        />

        <BookingDetailVisa
            :showRow="booking.isRow"
            :isShow="isShowVisaPopup"
            :onGoBack="closeVisaPopup"
            :cruiseVisa="bookingDetail.cruiseVisa"
            :boardingTime="bookingDetail.boardingTime"
            :portName="bookingDetail.harborCNName"
            :portAddress="bookingDetail.portAddress"
            :isShowSpecialBooking="isShowSpecialBooking"
        />

<!--        <BookingDetailNrp-->
<!--            :isShow="isShowNrpPopup"-->
<!--            :onGoBack="closeNrpPopup"-->
<!--            :isNrp="booking&&booking.isnrp"-->
<!--            :isFortyEightHoursNrp="bookingDetail.isFortyEightHoursNrpCruise"-->
<!--            :isSevenDayNrp="bookingDetail.isSevenDayNrpCruise"-->
<!--        />-->

         <!-- 舱房详情 -->
        <StateroomDetail
            :onGoBack="closeStateroomDetailPopup"
            :isShow="isShowStateroomDetailPopup"
            :stateroomDetail="selectStateroom"
            :showRow="booking.isRow"
        />

        <GtyPopup
            :onGoBack="closeGtyTips"
            :isShow="isShowGtyTips"
        />

        <ConnectRoomPopup
            :onGoBack="closeConnectRoomPopup"
            :isShow="isShowConnectRoomPopup"
        />

        <QiaohuPopup
            :shipCode="booking.shipCode"
            :sailDate="booking.sailDate"
            :onGoBack="closeQiaohuPopup"
            :isShow="isShowQiaohuPopup"
        />

        <StarrySkyPopup
            :shipCode="booking.shipCode"
            :sailDate="booking.sailDate"
            :onGoBack="closeStarrySkyPopup"
            :isShow="isShowStarrySkyPopup"
        />

        <CustomThemePopup
            :onGoBack="closeCustomThemePopup"
            :isShow="isShowCustomThemePopup"
            :themeInfo="personalizedStateroomInfo"
        />

        <GuestPassportPopup
            :onGoBack="closeGuestPassportPopup"
            :guest="targetGuest"
            :isShow="isShowGuestPassportPopup"
            :onGuestPassportChange="onGuestPassportChange"
        />

        <special-booking-rule-image-popup
            :specialRuleImage="specialBookingRuleImage"
            :closeSpecialBookingPopup="closeSpecialBookingPopup"
            v-show="isShowSpecialBookingRuleImagePopup"
            :specialName="specialBookingPopupTitleName"
            />

            <!-- 收费/常规退订弹窗 -->
            <NrpPopup
                :isShow="isShowNrpPopup"
                :nrpDescription="nrp.description"
                :onCloseNrpPopup="closeNrpPopup"
            />

            <!--服务费-->
            <GratuitiesPopup :isShow="isShowGratuitiesPopup"
                             :gratuitiesDescription="bookingDetail.gratuitiesPopupText"
                             :onCloseGratuitiesPopup="gratuitiesPopupClose"></GratuitiesPopup>
      <popups-img v-show="isShowPopupsImg"
                  :imgUrl="popupsImgUrl"
                  @closePopups="onClosePopups">
      </popups-img>
    </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import nrpConfig from '@/utilities/nrpConfig'
import _ from 'lodash'
import {differDays, numberWithCommas} from '@/utilities/tools'
import { SpecialBookingType } from '@/utilities/specialBookingHelper'
import NrpPopup from "@/components/Booking/NrpPopup.vue";
import GratuitiesPopup from "@/components/Booking/GratuitiesPopup.vue";
import { Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import PopupsImg from "@/components/Cruise/popupsImg.vue";
import StarrySkyPopup from "@/components/Cruise/StarrySkyPopup.vue";
import PcpGiftView from "@/components/PCP/PcpGiftView.vue";
const BookingDetailShorex = () => import('@/components/Booking/BookingDetailShorex')
const BookingDetailPcp = () => import('@/components/Booking/BookingDetailPcp')
const BookingDetailVisa = () => import('@/components/Booking/BookingDetailVisa')
// const BookingDetailNrp = () => import('@/components/Booking/BookingDetailNrp')
const StateroomDetail = () => import('@/components/Booking/StateroomDetail')
const GuestPassportPopup = () => import('@/components/Booking/GuestPassportPopup')
const GtyPopup = () => import('@/components/Booking/GtyPopup')
const QiaohuPopup = () => import('@/components/Cruise/QiaohuPopup')
const ConnectRoomPopup = () => import('@/components/Cruise/ConnectRoomPopup')
const SpecialBookingRuleImagePopup = () => import('@/components/Cruise/SpecialBookingRuleImagePopup')
const PrivacyButton = () => import('@/components/Common/PrivacyButton')
const GuestSelectView = () => import('@/components/Booking/GuestSelectView')
const GuestInfoContactList = () => import("@/components/Booking/GuestInfoContactList");
const CustomThemePopup =()=> import("@/components/Cruise/CustomThemePopup.vue");
const CruisePortsPopup = () => import("@/components/Booking/CruisePortsPopup");
export default {
    name: "BookingDetail",
    components: {
      PcpGiftView,
      StarrySkyPopup,
        PopupsImg,
        Swiper,
        SwiperSlide,
        GratuitiesPopup,
        BookingDetailShorex,
        BookingDetailPcp,
        BookingDetailVisa,
        // BookingDetailNrp,
        StateroomDetail,
        GtyPopup,
        QiaohuPopup,
        ConnectRoomPopup,
        GuestPassportPopup,
        SpecialBookingRuleImagePopup,
        PrivacyButton,
        GuestSelectView,
        GuestInfoContactList,
        NrpPopup,
        CustomThemePopup,
        CruisePortsPopup
    },
    directives: {
      swiper: directive,
    },
    data () {
        return {
            imgUrl: process.env.VUE_APP_IMG_URL,
            isHidePage: true,
            bookingDetail: {},
            targetGuest: {},
            selectStateroom: {},
            isShowGuestPassportPopup: false,
            isShowShorexPopup: false,
            isShowVisaPopup: false,
            isShowNrpPopup: false,
            isShowStateroomDetailPopup: false,
            isShowGtyTips: false,
            isShowConnectRoomPopup: false,
            isShowQiaohuPopup: false,
            isShowStarrySkyPopup: false,
            isShowSpecialBookingRuleImagePopup:false,
            refresh: null,
            isShowContactList: false,
            guestInfoDesc: "",
            isShowContactEdit: false,
            guests: [],
            guestsShow: [],
            maxGuestCount: 0,
            contactMode: "contact",
            selectContactIds: [],
            isShowGratuitiesPopup: false,
            gratuitiesSwitch: false,
            showGratuities: false,
            hsbcBanners:null,
            popupsImgUrl:'',
            isShowPopupsImg:false,
            swiperOptions: {
              pagination: {
                el: ".swiper-pagination",
              },
              loop: false,
              autoplay: {
                delay: 5000,
              },
            },
            isShowCustomThemePopup: false,
            personalizedStateroomInfo: null,
            pcpGiftInfo: null
        }
    },
    beforeMount () {
        this.$store.commit('SET_PAGE_TITLE', '订单详情')
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: true})
        this.initPage()
        window.onpopstate = () => {
            if (self.isShowContactEdit) {
              self.closeContactEdit();
            } else if (self.isShowContactList) {
              self.closeContactList();
            }
            if (this.isShowShorexPopup) {
                this.closeShorexPopup()
            }
            if (this.isShowVisaPopup) {
                this.closeVisaPopup()
            }
            if (this.isShowNrpPopup) {
                this.closeNrpPopup()
            }
            if (this.isShowStateroomDetailPopup) {
                this.closeStateroomDetailPopup()
            }
             if (this.isShowConnectRoomPopup) {
                this.closeConnectRoomPopup()
            }
            if (this.isShowQiaohuPopup) {
                this.closeQiaohuPopup()
            }
            if (this.isShowGuestPassportPopup) {
                this.closeGuestPassportPopup()
            }
        }
    },
    beforeDestroy () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
    },
    methods: {
        reload() {
          this.initPage();
          this.refresh = new Date().getTime();
        },
        async initPage() {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                return this.$router.push({ name: 'Login', query:{
                    returnUrl: encodeURIComponent(location.href)
                }})
            }

            const query = this.$router.currentRoute.query
            if (!query || !query.bookingId || query.bookingId == '') {
                return this.$router.push({ name: 'BookingSearch' })
            }

            this.selectStateroom = {}
            this.$loading.show()
            const { success, data, errMsg } = await api.booking.bookingDetail({
                // 使用加密字段encBookingId
                encBookingId: query.bookingId,
                userName: userToken
            })
            this.$loading.hide()
            if (!success) {
                console.error(errMsg)
            } else {
                this.bookingDetail = data
                this.guests = this.getGuests(data.bookingRecordApi);
                this.guestsShow = JSON.parse(JSON.stringify(this.guests));
                this.isHidePage = false
                this.showGratuities = this.bookingDetail.hasGratuities;
                console.log(this.showGratuities)
            }
          await this.getCruiseBanner()
        },
        getGuests(record) {
          let rows = [];
          let maxGuestCount = 0;
          record.bookingGuests.forEach((item,idx)=>{
            let newItem;
            record.bookingGuestExts.forEach(extItem=>{
              if(item.id === extItem.id) {
                newItem = extItem;
                item.unFilledGuest = extItem.unFilledGuest;
                item.passengerName = extItem.passengerName;
                item.enPassengerName = extItem.enPassengerName;
              }
            });
            if(newItem.unFilledGuest) {
              let row = {
                idx: idx,
                birthplace: null,
                callingCode: "86",
                chineseFirstName: null,
                chineseLastName: null,
                createdDate: null,
                dateOfBirth: null,
                email: null,
                firstName: null,
                gender: null,
                guestRef: null,
                guestId: item.id,
                encGuestId: item.encGuestId,  // 新增加密字段encGuestId
                id: null,
                issueAt: null,
                issuingDate: null,
                lastName: null,
                lastUpdateShorexDate: null,
                loyaltyId: "0",
                nationality: "CN",
                passPortExpirationDate: null,
                passPortNum: null,
                passengerName: newItem.passengerName,
                enPassengerName: newItem.enPassengerName,
                passport: null,
                passportExpiresIn: null,
                pinYinFirstName: null,
                pinYinLastName: null,
                pyFirstName: null,
                pyLastName: null,
                remark: null,
                rewardLoyaltyId: "",
                telephone: null,
                unFilledGuest: newItem.unFilledGuest
              }
              maxGuestCount += 1;
              rows.push(row);
            }
          });
          rows.forEach((r,idx)=> {r.isSelected = idx === 0; r.isEdit = false})
          this.maxGuestCount = maxGuestCount
          return rows;
        },
        getGuestPrice(index) {
            if (this.guestsPrice.length <= index) return {}
            return this.guestsPrice[index]
        },
        getGuestPassport (guest) {
            // if (guest.passPortNum && guest.passPortNum.length >= 5) {
            //     return guest.passPortNum.substr(0, 2) + "*****" + guest.passPortNum.substr(guest.passPortNum.length - 2, 2)
            // } else if (guest.passPortNum && guest.passPortNum.length > 0) {
            //     return "*****"
            // } else {
            //     return ""
            // }
            return guest.passPortNum;
        },
        getPassPortExpirationDate (guest) {
            // if (!guest.passPortExpirationDate || guest.passPortExpirationDate.length == 0) {
            //     return ""
            // } else if (guest.passPortExpirationDate.length < 10) {
            //     return guest.passPortExpirationDate
            // } else {
            //     return guest.passPortExpirationDate.substring(0, 10)
            // }
            if (!guest.passPortExpirationDateStr || guest.passPortExpirationDateStr.length == 0) {
              return "";
            } else {
              return guest.passPortExpirationDateStr;
            }
        },
        onSelectShorex (shorex) {
            this.bookingDetail.selectedShorex = shorex
            this.closeShorexPopup()
        },
        showShorexPopup () {
            this.isShowShorexPopup = true
            this.showPopup()
        },
        closeShorexPopup () {
            this.isShowShorexPopup = false
        },
        showVisaPopup () {
            this.isShowVisaPopup = true
            this.showPopup()
        },
        closeVisaPopup () {
            this.isShowVisaPopup = false
        },
        showNrpPopup () {
            this.isShowNrpPopup = true
            // this.showPopup()
        },
        closeNrpPopup () {
            this.isShowNrpPopup = false
        },
        // 客房详情
        showStateroomDetailPopup() {
            if (this.stateroom) {
                let suiteType = this.booking.stateroomPartView.suiteType;
                let stateroomType = this.booking.stateroomPartView.stateroomClassPartRecord.stateroomType;
                console.log(this.booking.stateroomPartView)
                this.selectStateroom = {
                    stateroomImages: this.stateroom.stateroomImages,
                    stateroomName: this.stateroom.stateroomCNName,
                    stateroomCategory: this.stateroom.stateroomCategoryCode,
                    stateroomPriceType: this.nrp.priceType,
                    stateroomPrice: 0,
                    stateroomCapacity: this.stateroom.stateroomCapacity,
                    stateroomArea: this.stateroom.stateroomArea,
                    stateroomBalcony: this.stateroom.stateroomBalconyArea,
                    stateroomFloor: '',
                    isQiaohu: this.bookingDetail.groupType == 'QIAOHU',
                    isStarrySky: this.bookingDetail.groupType == 'STARRYSKY',
                    isPcpGiftTheme: this.bookingDetail.groupType === 'PCPGIFT',
                    isCustomTheme: this.bookingDetail.groupType == 'CUSTOM',
                    stateroomDescription: this.stateroom.stateroomDescription,
                    stateroomNrpTitle: this.nrp.title,
                    stateroomNrpText: this.nrp.description,
                    suiteMobileImageUrl: this.stateroom.suiteMobileImageUrl,
                    stateroomShelter: this.bookingDetail.stateroomShelter,
                    deviceFeatureTags: this.bookingDetail.featureDeviceTags,
                    deviceGroupTags: this.bookingDetail.deviceTags,
                    suiteType: suiteType || null,
                    stateroomType: stateroomType || null,
                    personalizedStateroomInfo: this.bookingDetail.stateroomCategory.personalizedStateroomInfo,
                    stateroomImageDataList: this.bookingDetail.stateroomCategory.stateroomImageDataList,
                    roomSummaryList: this.bookingDetail.stateroomCategory.roomSummaryList || [],
                    suiteRightsCount: this.bookingDetail.stateroomCategory.suiteRightsCount
                }
                this.isShowStateroomDetailPopup = true
                this.showPopup()
            }
        },
        closeStateroomDetailPopup() {
            this.isShowStateroomDetailPopup = false
        },
        showGtyTips() {
            this.isShowGtyTips = true
        },
        closeGtyTips() {
            this.isShowGtyTips = false
        },
        showConnectRoomPopup () {
            this.isShowConnectRoomPopup = true
            this.showPopup()
        },
        closeConnectRoomPopup () {
            this.isShowConnectRoomPopup = false
        },
        showQiaohuPopup () {
            this.isShowQiaohuPopup = true
            this.showPopup()
        },
        closeQiaohuPopup () {
            this.isShowQiaohuPopup = false
        },
        showStarrySkyPopup () {
          this.isShowStarrySkyPopup = true
          this.showPopup()
        },
        closeStarrySkyPopup () {
          this.isShowStarrySkyPopup = false
        },
        showCustomThemePopup(val) {
          this.personalizedStateroomInfo = val;
          this.isShowCustomThemePopup = true;
          this.showPopup()
        },
        closeCustomThemePopup() {
          this.isShowCustomThemePopup = false;
        },
        showPopup() {
            history.pushState({ page: 'bookingDetail' }, null);
        },
        showBookingIntegralTips() {
            this.$alert.show('积分可兑换现金礼品卡、限量皇家周边、大额船票立减券等，还可参与免费船票抽奖~', {
                button: '我知道了'
            })
        },
        onChangeGuestPassport (guest) {
            this.targetGuest = guest
            this.isShowGuestPassportPopup = true
            this.showPopup()
        },
        onGuestPassportChange (guest) {
            this.isShowGuestPassportPopup = false
            let bookingGuest = this.bookingGuests.find(r=>r.id == guest.id)
            if (bookingGuest) {
                bookingGuest.passPortNum = guest.passPortNum
                bookingGuest.passPortExpirationDate = guest.passPortExpirationDate
                bookingGuest.passPortExpirationDateStr = guest.passPortExpirationDate
            }
        },
        closeGuestPassportPopup () {
            this.targetGuest = {}
            this.isShowGuestPassportPopup = false
        },
        showSpecialBookingPopup () {
            this.isShowSpecialBookingRuleImagePopup = true
        },
        closeSpecialBookingPopup () {
            this.isShowSpecialBookingRuleImagePopup = false
        },
        showContactList(val) {
          this.isShowContactList = true;
          this.guestInfoDesc = "同一航次，同一乘客不可重复添加";
          this.contactMode = val.contactMode;
          this.showPopup();
        },
        closeContactList() {
          this.isShowContactList = false;
        },
        closeContactEdit() {
          this.isShowContactEdit = false;
        },
        showContactEdit() {
          this.isShowContactEdit = true;
          this.showPopup();
        },
        onGuestContactConfirm(contacts) {
          this.guestsShow = JSON.parse(JSON.stringify(this.guests));
          contacts && contacts.forEach((row,index) => {
            this.setGuestInfo(this.guestsShow[index], row)
          });
          this.closeContactList();
        },
        /** 设置乘客信息 */
        setGuestInfo(guestsShow, guest) {
          if(guest) {
            guestsShow.id = guest.id;
            guestsShow.enPassengerName = guest.pinYinLastName + guest.pinYinFirstName;
            guestsShow.passengerName = guest.chineseLastName + guest.chineseFirstName;
            guestsShow.birthplace = guestsShow.dateOfBirth = guestsShow.birthDate = guest.dateOfBirth;
            guestsShow.callingCode = guest.callingCode;
            guestsShow.nationality = guest.nationality;
            guestsShow.chineseFirstName = guestsShow.firstName = guest.chineseFirstName;
            guestsShow.chineseLastName = guestsShow.lastName = guest.chineseLastName;
            guestsShow.email = guestsShow.email = guest.email;
            guestsShow.gender = guestsShow.gender = guest.gender;
            guestsShow.isEdit = true;
            guestsShow.passPortExpirationDate = guestsShow.passportExpiresIn = guest.passportExpirationDate;
            guestsShow.passPortNum = guestsShow.passport = guest.passportNum;
            guestsShow.pinYinFirstName = guestsShow.pyFirstName = guest.pinyinFirstName;
            guestsShow.pinYinLastName = guestsShow.pyLastName = guest.pinyinLastName;
            guestsShow.telephone = guest.telephone;
          }
      },
      /** 提交乘客信息 */
      submitFillGuests(){
        let guestNameComplete = '';
        let guestNameIncomplete = '';

        this.guestsShow.forEach(r => {
          if(r.isEdit) {
            guestNameComplete += r.passengerName + ',';
          } else {
            guestNameIncomplete += r.passengerName + ',';
          }
        });

        let guestNameCompleteHtml = '';
        let guestNameIncompleteHtml = '';
        let buttons = ['确定','取消'];
        if(guestNameComplete) {
          guestNameCompleteHtml = `<div class="confirm-text">
                          <span>${guestNameComplete.substr(0,guestNameComplete.length-1)}</span>已完成填写，一旦提交将无法自助修改，请务必确认乘客信息正确，且同一航次无重复乘客后再提交。</div>`;
        }
        if(!guestNameComplete && guestNameIncomplete) {
          guestNameIncompleteHtml = `<div class="confirm-text">您提交的乘客信息将不会被保存。</div>`;
          buttons = ['取消','确定离开'];
        }
        let confirmText = guestNameCompleteHtml ? guestNameCompleteHtml : guestNameIncompleteHtml;
        this.$confirm.show(confirmText, {
          confirmBtn: buttons[0],
          cancelBtn: buttons[1],
          confirmCallBack: () => {
            if(guestNameComplete) {
              this.updateGuests();
            }
          },
        });
      },
      // 提交乘客信息(提交接口)
      async updateGuests () {
        let allGuests = [];
        this.guests.forEach(r=>{
          this.guestsShow.forEach(item=>{
            if(item.guestId === r.guestId) {
              if(r.unFilledGuest) {
                item.id && allGuests.push({
                    //改为encId和encGuestId
                    encId: item.encGuestId,
                    firstName: item.firstName,
                    lastName: item.lastName,
                    birthDate: item.birthDate,
                    gender: item.gender,
                    pYFirstName: item.pyFirstName,
                    pYLastName: item.pyLastName,
                    telephone: item.telephone,
                    Email: item.email,
                    Passport: item.passPortNum,
                    PassportExpiresIn: item.passPortExpirationDate
                });
              }
            }
          });
        });
        console.log(allGuests)
        if(allGuests.length > 0) {
          this.$loading.show();
          const { success, errMsg } = await api.booking.updateGuests({
            encBookingRecordId: this.bookingDetail.bookingRecordApi.encBookingRecordId,// 改为encBookingRecordId
            allGuests: allGuests
          });
          this.$loading.hide();
          if (!success) {
            this.$alert.show(errMsg)
          } else {
            this.$alert.show('乘客信息提交成功，点击【确定】刷新页面。',{
              confirmCallBack: () => {
                this.initPage();
                // this.$router.go(0);
              }
            })
          }
        }
      },
      getTikTokCouponStatus(status) {
        if(status === 1) {
          return "待审核"
        } else if(status === 3) {
          return "已拒绝"
        } else {
          return '';
        }
      },
      gratuitiesPopupOpen() {
        this.isShowGratuitiesPopup = true;
      },
      gratuitiesPopupClose() {
        this.isShowGratuitiesPopup = false;
      },
      switchGratuities() {
        let days = differDays(this.bookingDetail.bookingRecordApi.cruisePartRecordView.sailDate);
        if(days >= 4 && days <= 10) {
          this.$alert.show("尊敬的乘客，服务费线上预付通道已关闭。如您仍想预付小费，请在开航日4天前联系在线客服或拨打客服电话 400-820-7293 进行支付。");
          return;
        } else if(days<=30) {
          this.$alert.show(`<div class="gratuitiesClickText">尊敬的乘客，服务费预付通道已关闭。${this.bookingDetail.gratuitiesClickText}</div>`);
          return;
        }

        this.gratuitiesSwitch = true;
        this.showGratuities = true;
        this.$confirm.show(`<div class="gratuitiesClickText">${this.bookingDetail.gratuitiesClickText}</div>`, {
          title: '确认预付服务费',
          cancelBtn: "船上支付",
          confirmBtn: "行前预付",
          confirmCallBack: async () => {
            this.$loading.show()
            const {success, data, errMsg} = await api.booking.updateBookingGratuities({
            // 改为encBookingId
              encBookingId: this.booking.encBookingId,
              gratuitiesPrepaid: this.gratuitiesSwitch
            })
            this.$loading.hide()
            if (success && data) {
              this.reload();
            } else {
              this.gratuitiesSwitch = false;
              this.showGratuities = false;
              this.$alert.show(errMsg || '订单提交失败，请重试')
            }
          },
          cancelCallBack: ()=> {
            this.gratuitiesSwitch = false;
            this.showGratuities = false;
          }
        })
      },
      async getCruiseBanner() {
        // console.log(123456)
        const requestData = {
          businessType:2
        }
        const {success, data, errMsg} = await api.cruise.getCruiseBannerApi(requestData);
        if (success) {
          this.hsbcBanners = data
          // console.log(this.hsbcBanners)
        } else {
          this.$alert.show(errMsg);
        }
      },
      onShowPopupsImg(idx){
        this.popupsImgUrl = ''
        this.popupsImgUrl = this.hsbcBanners[idx].popupImageUrl
        this.isShowPopupsImg = true
      },
      onClosePopups(){
        this.isShowPopupsImg = false
      },
      // 打开微信小程序
      async goToWxLink() {
          let params = {
          //改为encBookingRecordId  
          encBookingRecordId: this.bookingDetail.bookingRecordApi.encBookingRecordId
        }
        this.$loading.show();
        const {
          success,
          data,
          errMsg
        } = await api.booking.GetStateRoomUrlLink(params);
        this.$loading.hide();
          if (success) {
            console.log('GetStateRoomUrlLink',data)
          window.location.href = data
        } else {
          console.log(errMsg)
        }
      },
      getBiddingStatusText(biddingStatus) {
        switch (biddingStatus) {
          case 0:
            return '竞价升房中';
          case 10:
            return '竞价成功';
          case 20:
            return '未竞价成功';
          case 30:
            return '竞价升房';
          case 40:
            return '竞价成功未付款';
          case 50:
            return '竞价成功已付款';
          default:
            return '';
        }
    },
      async goToPcp () {
        const { data } = await api.user.getPcpToken()
        let token = ""
        if (data && data.length > 0) {
          token = data
        }
        const url = `${process.env.VUE_APP_PCP_URL}/Rccl.Pcp/product/pcpShorex?token=${token}`
        location.href = url
      },
      // 判断是否为整数
      calculateDecimal(price){
        if(price){
          if((Number.isInteger(price))){
            return price
          }else{
            return Number(price).toFixed(2)
          }
        }
        return 0;
      },
      getPcpGift(val) {
        this.pcpGiftInfo = val
      },
      editInfo() {
        window.location.href = `/Rccl.UserCenter/CustomerInfo/EditInfo?returnUrl=${encodeURIComponent(
            location.href
        )}`
      }
    },
    computed: {
        booking() {
            return this.bookingDetail.bookingRecordApi || {}
        },
        bookingGuests () {
            if (!this.booking) return []
            return this.booking.bookingGuests || []
        },
        agency () {
            return this.bookingDetail.agency
        },
        bookingPrice () {
            return this.bookingDetail.bookingPrice
        },
        guestsPrice () {
            if (!this.bookingPrice) return []
            return this.bookingPrice.guestsPrice || []
        },
        discountPriceItems () {
            if (!this.bookingPrice || !this.bookingPrice.prices
            || !this.bookingPrice.prices.priceInfo || this.bookingPrice.prices.priceInfo.length == 0) {
                return []
            }
            const discountPrice = this.bookingPrice.prices.priceInfo.find(r=>r.priceTypeCode == 'DISCOUNT')
            if (discountPrice && discountPrice.priceItems) return discountPrice.priceItems
            return []
        },
        discountedPrice () {
            if (!this.bookingPrice || !this.bookingPrice.priceInfo) return 0
            // return this.bookingPrice.priceInfo.cabinPrice + this.bookingPrice.priceInfo.portPrice
            // + this.bookingPrice.priceInfo.optionPrice + this.bookingPrice.priceInfo.discountPrice + this.bookingPrice.priceInfo.gratuities
            return (
                this.bookingPrice.priceInfo.originalPrice +
                this.bookingPrice.priceInfo.discountPrice
            );
        },
        isShowPrice () {
            return this.agency && (this.agency.agencyType == 1 || this.agency.agencyType == 3)
        },
        pcpOrder () {
            return this.bookingDetail.pcpOrderViewModel
        },
        bookingPays () {
            return this.bookingDetail.bookingPays || []
        },
        contact () {
          if(this.bookingDetail && this.bookingDetail.bookingRecordApi) {
            return this.bookingDetail.bookingRecordApi.bookingContacts[0] || {}
          } else {
            return {}
          }
        },
        contactName () {
            if (!this.contact) {
                return ""
            }
            if (this.contact.chineseLastName && this.contact.chineseLastName.length > 0
            && this.contact.chineseFirstName && this.contact.chineseFirstName.length > 0) {
                return `${this.contact.chineseLastName}${this.contact.chineseFirstName}`
            }
            return `${this.contact.pinYinLastName} ${this.contact.pinYinFirstName}`
        },
        cruise () {
            if (!this.booking || !this.booking.cruisePartRecordView) {
                return {}
            }
            return this.booking.cruisePartRecordView
        },
        retainTime () {
            if (!this.booking || !this.booking.createdDate) {
                return ''
            }
            const createDate = moment(this.booking.createdDate)
            if (this.bookingDetail.groupType == 'QIAOHU') {
                return createDate.add(2, 'hours').format('YYYY-MM-DD HH:mm:ss')
            } else if (this.bookingPays.length > 0 && this.booking.finalPaymentTime != '') {
                return this.booking.finalPaymentTime
            } else {
                return createDate.add(24, 'hours').format('YYYY-MM-DD HH:mm:ss')
            }
        },
        currency () {
            if (this.bookingDetail.bookingCurrency) {
                return this.bookingDetail.bookingCurrency.currencyIcon
            } else if (this.booking.currency == "CNY") {
                return "￥"
            } else if (this.booking.currency == "USD") {
                return "$"
            }
            return ""
        },
        payAmount () {
            if (this.bookingPays.length > 0) {
              let price = _.sumBy(this.bookingPays, 'amount')
              return this.calculateDecimal(price)
            }
            return 0
        },
        canPay () {
            return this.bookingDetail.canPay
        },
        balanceDue () {
            return this.bookingDetail.balanceDue
        },
        stateroom () {
            return this.bookingDetail.stateroomCategory
        },
        stateroomName () {
            if (!this.stateroom) {
                return ""
            }
            let stateroomCNName = this.stateroom.stateroomCNName || ''
            if (this.bookingDetail.stateroomShelter && this.bookingDetail.stateroomShelter.length > 0
            && stateroomCNName.indexOf('遮挡') < 0) {
                stateroomCNName += '（有遮挡）'
            }
            return stateroomCNName
        },
        stateroomCategoryCode () {
            if (!this.stateroom) {
                return ""
            }
            let code = this.stateroom.stateroomCategoryCode
            if (code.indexOf('_') >= 0) {
                code = code.split('_')[0]
            }
            return code
        },
        nrp () {
            if (this.bookingDetail.isSevenDayNrpCruise) {
                return nrpConfig.sevenDayNrp
            } else if (this.bookingDetail.isFortyEightHoursNrpCruise) {
                return nrpConfig.fortyEightHoursNrp
            } else if (this.booking.isnrp) {
                // 收费退订
                if(this.booking.isRow){
                    return {
                        title: '收费退订',
                        description:this.$store.state.cruiseRow.nrpData.cancelPolicyNrpRow}
                }else{
                    return {
                        title: '收费退订',
                        description:this.$store.state.cruiseRow.nrpData.cancelPolicyNrp
                    }
                }
                // return nrpConfig.nrp
            } else {
                // 常规退订
                if(this.booking.isRow){
                    return {
                        title: '常规退订',
                        description:this.$store.state.cruiseRow.nrpData.cancelPolicyRow
                    }
                }else{
                    return{
                        title: '常规退订',
                        description:this.$store.state.cruiseRow.nrpData.cancelPolicy
                    }
                }
            }
        },
        nrpText () {
            return this.nrp.title
        },
        isExpired () {
            if (!this.booking || !this.booking.sailDate || this.booking.sailDate == '') {
                return true
            }
            const sailDate = moment(this.booking.sailDate)
            const today = moment()
            return today >= sailDate
        },
        isNotPayInFull () {
            return this.payAmount > 0 && this.balanceDue > 0 && this.payAmount < this.booking.amount
        },
        shorexes () {
            return this.bookingDetail.shorexs || []
        },
        selectedShorex () {
            return this.bookingDetail.selectedShorex
        },
        changeBookingContactLink() {
            // 改为encBookingId
            if (process.browser) {
                return { name: 'ChangeBookingContact', query: { bookingId: this.booking.encBookingId, returnUrl: location.href }}
            } else {
                return { name: 'ChangeBookingContact', query: { bookingId: this.booking.encBookingId }}
            }

        },
        canShorex () {
            const agency = this.bookingDetail.agency || {}
            return agency.canShorex && !agency.onlyOperateAdmin
        },
        integral () {
            return numberWithCommas(this.bookingDetail.bookingIntegral.integral)
        },
        bookingGuestSpecials () {
            return this.booking.bookingGuestSpecials || []
        },
        specialBooking () {
            return this.bookingGuestSpecials.length == 0 ? {}: this.bookingGuestSpecials[0]
        },
        selectedGuestName () {
            if(this.bookingGuestSpecials && this.bookingGuestSpecials.length > 0){
                let guestNames = ''
                for(let i = 0; i < this.bookingGuestSpecials.length; i ++){
                    let name = this.bookingGuestSpecials[i].guestName
                    if(!name || name.length == 0){
                        name = this.bookingGuestSpecials[i].guestEnName
                    }
                    guestNames += name
                    if(i != (this.bookingGuestSpecials.length - 1)){
                        guestNames += "、"
                    }
                }
                return guestNames
            }
            return ""
        },
        selectedDate () {
            return this.specialBooking.specialBookingDate || ""
        },
        selectedTimeslot () {
            return this.specialBooking.specialBookingTimeslot || ""
        },
        selectedPlace () {
            return this.specialBooking.specialBookingPlace || ""
        },
        specialBookingType () {
            return this.specialBooking.specialBookingType || 0
        },
        specialBookingName () {
            if(this.specialBookingType == SpecialBookingType.Birthday){
                return "享受收费生日礼遇"
            }
            else if(this.specialBookingType == 2){
                return "享受收费周年礼遇"
            }
            return ""
        },
        specialBookingPopupTitleName () {
            if(this.specialBookingType == SpecialBookingType.Birthday){
                return "享受生日礼遇"
            }
            else if(this.specialBookingType == 2){
                return "享受周年礼遇"
            }
            return ""
        },
        specialBookingRuleImage () {
            return this.specialBooking.mobileRuleDescriptionImage || ""
        },
        isShowSpecialBooking () {
            return this.bookingGuestSpecials.length > 0
        },
        upgradeCabinItem(){
            return this.bookingDetail.upgradeCabinItem || {}
        },
        isFinishSelfInfo() {
          let userInfo = this.$store.state.user.userInfo;
          let isLocalReward = userInfo && userInfo?.userIdentity && userInfo.userIdentity === 1
          return isLocalReward && userInfo.infoIntegrity === 100;
        }
    },
     watch: {
        $route() {
            if (this.$router.currentRoute.query.bookingId && this.booking.bookingId
            && this.$router.currentRoute.query.bookingId != this.booking.bookingId) {
                this.initPage()
            }
        }
    }
}
</script>

<style lang="less" scoped>
#bookingDetailPage {
    background: #F6F7F8;
    padding: 0px 0 50px 0;
    img {
        max-width: 100%;
    }
    .modify-box {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin-left: 8px;
        font-size: 12px;
        line-height: 16px;
        color: #4A90E2;
        font-weight: bold;
        img {
            display: block;
            width: 13px;
            margin-right: 5px;
        }
    }
    .count-down {
        margin: 0 15px;
        padding: 10px 0 11px;
        font-size: 10px;
        line-height: 14px;
        color: #999;
        text-align: center;
        span {
            color: rgba(255, 80, 85, 1.0);
        }
    }
    .tik-tok-header {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      height: 52px;
      color: #666;
      text-align: center;
    }
    .route-info {
        margin-bottom: 10px;
        padding: 16px 20px 12px;
        background-color: #fff;
        position: relative;
        & .route-name-box {
          display: flex;
          justify-content: space-between;
          .route-name-box__left {
            padding-bottom: 5px;
            //padding-right: 3.5rem;
            font-size: 14px;
            line-height: 20px;
            color: #333;
            max-width: calc(100% - 3.5rem);
            font-weight: bold;
          }
          .route-name-box__right {
            margin-top: -1px;
            margin-right: -10px;
          }
        }
        .route-ship {
            padding-bottom: 7px;
            padding-right: 3.5rem;
            font-size: 12px;
            line-height: 16px;
            color: #666;
        }
        .route-row {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            padding-bottom: 6px;
            position: relative;
            .route-row-title {
                -webkit-box-flex: 0;
                -webkit-flex: none;
                -moz-box-flex: 0;
                -ms-flex: none;
                flex: none;
                width: 48px;
                font-size: 12px;
                line-height: 16px;
                color: #666;
            }
            .route-row-txt {
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -moz-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                font-size: 12px;
                line-height: 12px;
                color: #151515;
            }
            .route-row-txt3 {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
            }
          .stateRoomBidding{
            display: flex;
            align-items: center;
            gap: 3px;
            position: absolute;
            top: -5px;
            right: -20px;
            padding: 6px 9px;
            font-size: 10px;
            background-color: #ffd33e;
            color: #fff;
            border-radius: 22px 0 0 22px;
            img{
              width: 13px;
              height: 13px;
            }
          }

        }
        .route-row2 {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-flex-wrap: wrap;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            margin-left: 60px;
            font-size: 12px;
            line-height: 12px;
            color: #666;
            .route-row2-txt {
                margin-right: 10px;
                padding-right: 10px;
                border-right: 1px solid #979797;
                word-break: break-all;
            }
            .route-row2-txt {
                margin-right: 10px;
                padding-right: 10px;
                border-right: 1px solid #979797;
                word-break: break-all;
            }
            .route-row2-txt:last-child {
                margin-right: 0;
                padding-right: 0;
                border-right: none;
            }

        }
    }
    .order {
        width: 355px;
        margin: 0 auto 10px;
        padding: 0 10px;
        border-radius: 5px;
        background-color: #fff;
        border: 1px solid #FEBC10;
        border-top: 5px solid #FEBC10;
        -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        .order-info {
            padding-top: 18px;
            .order-row1 {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                .order-row1-l {
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                    -moz-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: flex;
                }
                .order-row1-r {
                    font-size: 12px;
                    line-height: 22px;
                    color: #4A90E2;
                }
            }
            .order-row2 {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                padding-top: 6px;
            }
            .order-row2-r {
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -moz-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                -webkit-flex-wrap: wrap;
                -ms-flex-wrap: wrap;
                flex-wrap: wrap;
                margin-left: 10px;
            }
            .order-row2-r.c_order-row2-r {
                margin-left: 0px;
                margin-top: 8px;
            }

            .order-badge {
                min-width: 62px;
                margin: 0 11px 3px 0;
                padding: 0 5px;
                font-size: 11px;
                line-height: 15px;
                color: #fff;
                text-align: center;
                background-color: #FEBC10;
                border-radius: 2px;
            }
            .order-badge2 {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                margin: 0 9px 3px 0;
                font-size: 11px;
                line-height: 15px;
                color: #4A90E2;
                font-weight: bold;
                img {
                    display: block;
                    width: 12px;
                    margin-left: 1px;
                    position: relative;
                    top: -1px;
                }
            }
            .order-line {
                margin-top: 8px;
            }

        }
        .order-passenger {
            padding-top: 16px;
            .passenger-name {
                padding-bottom: 7px;
                font-size: 14px;
                line-height: 20px;
                color: #333;
                font-weight: bold;
                .cn {
                    display: inline-block;
                    margin-right: 20px;
                }
            }
            .passenger-info {
                padding-bottom: 7px;
                .passenger-info-row {
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: flex;
                    padding-bottom: 8px;
                    p {
                        margin: 0 12px 0 0;
                        padding-right: 12px;
                        &:first-child {
                            border-right: 1px solid #999;
                        }
                    }
                }
                .modify-box {
                    margin-left: 0;
                }
            }
            .passenger-service {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                padding-bottom: 8px;
                .passenger-service-l {
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                    -moz-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    font-size: 12px;
                    line-height: 16px;
                    color: #333;
                }
                .passenger-service-r {
                    font-size: 12px;
                    line-height: 14px;
                    color: #151515;
                    span {
                        font-size: 10px;
                    }
                }
            }

        }
        .order-price {
            padding-top: 17px;
            .order-price-title {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                padding-bottom: 10px;

            }
            .order-price-row {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                padding-bottom: 8px;
                .order-price-row-l {
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                    -moz-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    font-size: 12px;
                    line-height: 16px;
                    color: #4A90E2;
                    text-indent: 15px;
                }
                .order-price-row-r {
                    font-size: 12px;
                    line-height: 14px;
                    color: #4A90E2;
                    span {
                        font-size: 10px;
                    }
                }
            }
            .order-price-row2 {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                padding-bottom: 9px;
            }
            .order-price-title-l {
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -moz-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                font-size: 14px;
                line-height: 20px;
                color: #333;
                font-weight: bold;
            }
            .order-price-title-r {
                font-size: 12px;
                line-height: 14px;
                color: #151515;
                span {
                    font-size: 10px;
                }
            }
            .order-price-row2-l {
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -moz-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                font-size: 14px;
                line-height: 20px;
                color: #4A90E2;
                font-weight: bold;
            }
        }
        .order-summary {
            padding-top: 19px;
            padding-bottom: 28px;
            .order-summary-row {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: end;
                -webkit-justify-content: flex-end;
                -moz-box-pack: end;
                -ms-flex-pack: end;
                justify-content: flex-end;
                padding-bottom: 8px;
                font-weight: bold;
                .order-summary-row-l {
                    margin-right: 5px;
                    font-size: 14px;
                    line-height: 20px;
                    color: #333;
                }
                .order-summary-row-r {
                    font-size: 15px;
                    line-height: 20px;
                    color: #FF5055;
                    span {
                        display: inline-block;
                        margin-right: 3px;
                        font-size: 15px;
                    }
                }
            }
            .order-summary-jifen {
                font-size: 12px;
                color: #333;
                text-align: right;
                span {
                    color: #4A90E2;
                }
                img {
                    margin-left: 1px;
                    width: 12px;
                    vertical-align: -2px;
                }
            }
        }
    }

    .order-txt1 {
        font-size: 14px;
        line-height: 22px;
        color: #4A90E2;
        font-weight: bold;
    }
    .order-txt2 {
        font-size: 14px;
        line-height: 22px;
        color: #151515;
        font-weight: bold;
    }
    .order-txt3 {
        font-size: 12px;
        line-height: 18px;
        color: #333;
        font-weight: bold;
        display: flex;
        align-items: flex-start;
    }
    .order-txt4 {
        font-size: 12px;
        line-height: 1;
        color: #666;
    }
    .order-txt5 {
        font-size: 12px;
        line-height: 16px;
        color: #333;
    }

    // 特别礼遇
    .specialBookingArea {
        font-size: 12px;
    }

    .specialBookingArea .specialBookingName{
        color: #4A90E2;
        vertical-align: middle;
    }

    .specialBookingArea .item-sp{
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .specialBookingArea .item-title-row{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .specialBookingArea .itemContent{
        font-size: 11px;
    }

    .specialBookingArea .selectedUnderline{
        text-decoration: underline;
        color: #000;
    }

    .specialBookingArea .special-icon{
        width: 18px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
    }

    .specialBookingArea .question-icon{
        width: 14px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 5px;
    }

    .specialBookingArea .item-selected-content{
        padding-top: 8px;
    }

    .specialBookingArea .itemContent{
        margin-left: 23px;
    }

    .order-line {
        width: 100%;
        height: 1px;
        background: url(https://resource.rcclchina.com.cn/paySuccess/order-line.png) repeat-x;
        -webkit-background-size: auto 100%;
        -o-background-size: auto 100%;
        background-size: auto 100%;
    }

    .toolbar {
        position: fixed;
        .toPay-m {
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 10100;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            width: 100%;
            height: 49px;
            .toPay-m-l {
                -webkit-box-flex: 0;
                -webkit-flex: none;
                -moz-box-flex: 0;
                -ms-flex: none;
                flex: none;
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                width: 253px;
                padding: 0 20px;
                background-color: #4A90E2;
                color: #fff;
                .toPay-m-txt {
                    font-size: 14px;
                    line-height: 20px;
                    .unit {
                        font-size: 12px;
                        line-height: 20px;
                    }
                }
                .toPay-m-price {
                    font-size: 18px;
                    line-height: 25px;
                    font-weight: bold;
                }
            }
            .toPay-m-r {
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -moz-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: center;
                -webkit-justify-content: center;
                -moz-box-pack: center;
                -ms-flex-pack: center;
                justify-content: center;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                font-size: 14px;
                line-height: 1;
                color: #454545;
                letter-spacing: 1px;
                font-weight: bold;
                background: -webkit-gradient(linear, left top, right top, from(#FEBC10), to(#FAD961));
                background: -webkit-linear-gradient(left, #FEBC10, #FAD961);
                background: -moz-linear-gradient(left, #FEBC10, #FAD961);
                background: -o-linear-gradient(left, #FEBC10, #FAD961);
                background: linear-gradient(to right, #FEBC10, #FAD961);
            }
        }
    }

    .booking-service {
        .shorex-service {
            background: #fff;
            padding: 17px 0 20px;
            margin-bottom: 10px;
            .shorex-ly {
                display: flex;
                padding: 0px 16px 0px 28px;
                .f-left {
                    color: #4A90E2;
                    font-size: 12px;
                    margin-right: 8px;
                    flex: none;
                    font-weight: bold;
                }
                .f-right {
                    color: #454545;
                    font-size: 14px;
                    width: 90px;
                    background: #FEBC10;
                    text-align: center;
                    flex: none;
                    line-height: 25px;
                    position: relative;
                    top: -2px;
                }
            }
            .shorex-intro {
                padding: 0px 16px 0 28px;
                font-size: 12px;
                .per-title {
                    color: #333;
                    font-weight: bold;
                }
                .sub-title {
                    color: #666;
                }
                .sh {
                    display: flex;
                    color: #666;
                }
            }
            .selectShorex-css{
              font-size: 12px;
              margin: 0;
              color: #666666;
              padding: 0 28px;
              span {
                color: #408eca;
              }
            }
            .shorex-tips {
                font-size: 11px;
                color: #666;
                padding: 0px 20px 0px 28px;
                p {
                    margin: 0px;
                }
                .parah-num {
                    display: inline-block;
                    width: 15px;
                }
            }
            .imaginary {
                border-top: 1px dotted #CCCCCC;
                flex: 1;
                margin-right: 8px;
                margin-top: 10px;
            }
            .shorexTour-intro {
                padding: 11px 38px 0 28px;
                font-size: 12px;
                display: flex;
                img {
                    max-width: 100px;
                    max-height: 75px;
                    flex: none;
                }
                .shorexTour-Info {
                    flex: 1;
                    margin-left: 12px;
                    .shorexTour-per-title {
                        font-size: 12px;
                        color: #333333;
                        letter-spacing: 0;
                        font-weight: bold;
                    }
                    .shorexTour-sub-title {
                        font-size: 12px;
                        color: #666666;
                        letter-spacing: 0;
                        line-height: 18px;
                        margin-top: 2px;
                        >span {
                            color: #151515;
                        }
                    }
                }
            }
            .all-imaginary {
                border-bottom: 1px solid #CCCCCC;
                width: 90%;
                margin: 10px 0 10px 5%;
            }
            .shorexTour-price {
                float: right;
                font-size: 12px;
                margin-right: 24px;
                span {
                    font-size: 15px;
                    color: #FF5055;
                    letter-spacing: -1.42px;
                    text-align: right;
                    line-height: 20px;
                }
            }
        }

        .orderNotesCon {
            // padding-top: 10px;
            .package-orderNotes-category {
                margin-bottom: 10px;
                padding: 10px 20px;
                background-color: #fff;
                .package-orderNotes-headline {
                    overflow: hidden;
                    .package-orderNotes-headline-l {
                        height: 14px;
                        line-height: 14px;
                        float: left;
                        display: inline-block;
                        font-family: PingFang-SC-Medium;
                        font-size: 14px;
                        color: #4A90E2;
                        letter-spacing: 1px;
                        padding-left: 8px;
                        border-left: 3px solid #4A90E2;
                        position: relative;
                        top: 6px;
                        font-weight: 600;
                    }
                    .package-orderNotes-headline-r {
                        float: right;
                        margin-right: 4px;
                        img {
                            width: 8px;
                        }
                    }
                }
            }
        }
        .pay-rule-item {
            display: flex;
            align-items: center;
            font-size: 14px;
            line-height: 20px;
            color: #4A90E2;
            padding-left: 20px;
            position: relative;
            margin-bottom: 7px;
            .pay-rule-item-line {
                width: 3px;
                height: 12px;
                margin-right: 6px;
                background-color: #4A90E2;
            }
            p {
                font-weight: bold;
                margin: 0;
            }
        }
    }
    .c_con_BD {
        width: 97px;
        position: relative;
        top: 3px;
        margin-left: 5px;
    }
    .c_con_BDLook {
        width: 134px;
        position: relative;
        top: 3px;
        margin-left: 4px;
    }
    .QIAOHU_CSS {
        height: 18px;
        margin-left: 5px;
    }
    .STARRYSKY_CSS {
      height: 18px;
      margin-left: 5px;
    }
    .PCP_GIFT_THEME_CSS {
      height: 18px;
      margin-left: 5px;
    }
    .CUSTOM_THEME_CSS {
      height: 18px;
      margin-left: 5px;
    }
}
.booking-fill-guests {
  padding: 20px 0;
  overflow: hidden;
  & .booking-fill-guests-btn {
    font-size: 12px;
    display: block;
    width: 85px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    border-radius: 3px;
    font-weight: bold;
    margin: 10px auto 0;
    background-color: #FBC500;
    color: #333333;
    border: none;
    &:active {
      opacity: .8;
    }
  }
}
.privacy-layout {
  font-size: 0;
  line-height: 1;
  position: absolute;
  bottom: 0.35rem;
  right: 16px;
}
</style>

<style lang="less">
#bookingDetailPage .booking-service .shorex-service .shorex-intro .sub-title p {
    font-size: 12px !important;
    color: #666 !important;
    margin: 5px 0;
}

#bookingDetailPage {
    #stateroomDetail .blue {
        color: #4A90E2;
    }

    .fortyEightHoursNrpSwitchTips {
        display: none;
    }
}
.confirm-text {
  //color: #777777;
  & span {
    font-weight: bold;
    margin-right: 5px;
    color: #001654;
  }
}
.cabinItem-un-filled {
  overflow: hidden;
  font-size: 12px;
  margin-top: 12px;
  color: #4A90E2;
  & .icon {
    height: 12px;
    float: left;
    margin-right: 4px;
    margin-top: 2px;
  }
  & .text {
    line-height: 18px;
    overflow: hidden;
    letter-spacing: -1px;
  }
}

.cabinItem-checkbox {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 7px;
  position: relative;
  z-index: 100;

  .cabinItem-checkbox-l {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding-right: 10px;
    font-size: 12px;
    line-height: 16px;
    color: #333;
    img {
      margin-left: 1px;
      width: 14px;
      vertical-align: -2px;
    }
  }
  .cabinItem-checkbox-r {
    -webkit-box-flex: 0;
    -webkit-flex: none;
    -moz-box-flex: 0;
    -ms-flex: none;
    flex: none;
  }

  & .switchBar {
    position: relative;
    width: 34px;
    height: 16px;
    border-radius: 10px;
    &.active .switchBarSlider {
      background-color: #0795ff;
    }
    &.active .switchBarSlider::before {
      transform: translateX(18px);
    }
    & .switchBarSlider {
      position: absolute;
      left: 0;
      top: 0;
      width: 34px;
      height: 16px;
      border-radius: 10px;
      background-color: #ccc;
      transition: .4s;
      &::before {
        content: ' ';
        position: absolute;
        left: 0;
        top: 0;
        width: 16px;
        height: 16px;
        border-radius: 100%;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .3);
        background-color: #FFFFFF;
        transition: .4s;
        transform: translateX(0);
      }
    }
  }
}
.hsbcBanner{
  width: 100%;
  height: 100px;
  margin: 10px 0;
  padding: 0 15px;
  &  .swiper-container {
    width: 100%;
    height: 100px;
    border-radius: 5px;
    overflow: hidden;
  }
  & .swiper-slide{
    width: 100%;
    height: 100px;
  }
  & img{
    width: 100%;
    height: 100px;
  }
}
.gratuitiesClickText {
  text-align: left;
  max-height: 50vh;
  overflow: hidden;
  overflow-y: auto;
}
.gratuitiesClickText p {
  margin: 0 0;
}
.stateRoomWxLink{
  display: flex;
  align-items: center;
  font-size: 10px;
  color: #4990e2;
  height: 15px;
  margin: 0 11px 3px 0;
  img{
    width: 9px;
    height: 9px;
  }
}

.margin-bottom-10{
    margin-bottom: 10px;
}
</style>
